<!--
 * @Description: 上传附件
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @Date: 2023-06-25 13:42:08
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
 * @LastEditTime: 2023-11-14 13:59:20
-->
<template>
  <div class="cloud-page-com">
    <jw-modal :visible="visible" @ok="handleOk" @cancel="handleCancel" :class="{ 'cloud-modal': formHeight ? true : false }" title-align="start" width="550px" :mask-closable="false" unmount-on-close>
      <template #title> {{ $t('上传附件') }} </template>
      <jw-form :model="form" label-align="right" auto-label-width ref="cloudForm" @submit="handleSubmit" class="select-item">
        <jw-form-item :label="$t('本地附件')" field="file" show-colon :rules="{ required: true, message: $t('请上传本地附件') }" required :validate-trigger="['blur', 'input', 'change']">
          <div class="cloud-item-list">
            <jw-upload :disabled="uploadDisabled" :action="actionUrl" v-model:file-list="fileList" name="file" :multiple="true" :data="{ businessId: id, type: type, documentType: form.documentType }" :headers="headers" ref="uploadRef" @change="uploadChange" @before-upload="beforeUpload" :auto-upload="false" :show-retry-button="false" />
            <p class="tips-text">{{ $t('支持上传') }}.jpg .jpeg .png .docx .xlsx .xls .pdf{{ $t('等格式的文件') }}</p>
          </div>
        </jw-form-item>
        <jw-form-item :label="$t('附件类型')" field="documentType" show-colon :rules="{ required: true, message: $t('请选择附件类型') }" :validate-trigger="['blur', 'input', 'change']">
          <jw-select :trigger-props="{ updateAtScroll: true }" :style="{ width: '300px' }" v-model="form.documentType" :placeholder="$t('请选择附件类型')" allow-clear :filter-option="false" allow-search>
            <jw-option v-for="item of typeOptions" :key="item.value" :value="item.value">{{ item.label }}</jw-option>
          </jw-select>
        </jw-form-item>
      </jw-form>
      <template #footer>
        <div class="cloud-footer">
          <jw-space>
            <jw-button @click="handleCancel">{{ $t('取消') }}</jw-button>
            <jw-button type="primary" :loading="loading" @click="handleOk">{{ $t('确定') }}</jw-button>
          </jw-space>
        </div>
      </template>
    </jw-modal>
  </div>
</template>
<script>
import { reactive, ref, toRefs, watch, inject } from 'vue';
import { Message } from '@arco-design/web-vue';
import { getToken } from '@/utils/auth';
import { opportunityService } from '@/api/';
import { useI18n } from 'vue-i18n';
import { huaYingOrdId } from '@/utils/const';
import { useUserStore } from '@/store';
export default {
  setup(props, ctx) {
    const { t } = useI18n();
    const visible = ref(false);
    const cloudForm = ref(); //表单
    const formHeight = ref(false);
    const token = getToken() || null;
    const uploadRef = ref();
    const { userInfo } = useUserStore();
    const data = reactive({
      form: {
        file: [],
        documentType: ''
      },
      headers: {
        authorization: `Bearer ${token}`
      },
      id: inject('detailParams').id, //id,
      type: inject('detailParams').entity,
      actionUrl: '/api/cloud/document/upload',
      typeOptions: [],
      loading: false,
      uploadData: [],
      fileList: [],
      uploadDisabled: false
    });
    const open = async () => {
      await getDocumentTypeList();
      data.form = {
        file: [],
        documentType: ''
      };
      data.fileList = [];
      visible.value = true;
    };
    const handleOk = () => {
      cloudForm.value.handleSubmit();
    };
    const handleCancel = () => {
      cloudForm.value.resetFields();
      visible.value = false;
      data.loading = false;
      data.uploadDisabled = false;
    };
    //获取文件类型
    const getDocumentTypeList = async () => {
      const params = {
        enumClassName: userInfo?.orgId != huaYingOrdId ? 'DocumentTypeEnum' : 'DocumentTypeHuaYingEnum'
      };
      try {
        const json = await opportunityService.getDocumentTypeList(params);

        if (json.error) {
          Message.error(json.error?.msg || t('操作失败'));
        }
        data.typeOptions = json?.result;
        console.log(data.typeOptions);
      } catch (e) {
        console.log(e);
      }
    };
    //表单提交
    const handleSubmit = ({ values, errors }) => {
      console.log('values', values);
      console.log('errors', errors);
      if (errors) {
        const errorArray = {};
        Object.values(errors).forEach((key, index) => {
          errorArray[key.field] = { status: 'error', message: '' };
          Object.values(errorArray).forEach((i, ind) => {
            if (index === ind) {
              i.message = key.message;
            }
          });
        });
        cloudForm.value.setFields(errorArray);
        return;
      }
      data.loading = true;
      data.uploadDisabled = true;
      uploadRef.value.submit();
    };
    // 上传前效验文件大小
    const beforeUpload = (file) => {
      console.log('file上传前', file);

      const name = file.name;
      const namelist = [];

      data.form.file?.map((el) => namelist.push(el.name));
      console.log(namelist);
      if (namelist.indexOf(name) > -1) {
        Message.error(t('tips.fileExists'));
        return false;
      }
      if (data.form.file.length >= 10) {
        Message.error(t('tips.limitTen'));
        return false;
      }
      const fileType = name.split('.')[1];
      const typeList = ['jpg', 'jpeg', 'png', 'docx', 'docm', 'doc', 'xlsx', 'xls', 'txt'];
      const type = ['pptx', 'pdf', 'key'];
      if (typeList.indexOf(fileType) > -1) {
        if (file.size / 1024 / 1024 > 25) {
          Message.error(t('tips.uploadError') + '25M');
          return false;
        }
      } else if (type.indexOf(fileType) > -1) {
        if (file.size / 1024 / 1024 > 50) {
          Message.error(t('tips.uploadError') + '50M');
          return false;
        }
      } else {
        if (file.size / 1024 / 1024 > 25) {
          Message.error(t('tips.uploadError') + '25M');
          return false;
        }
      }
      return true;
    };
    //
    const uploadChange = (fileList, fileItem) => {
      console.log(fileList);
      console.log(fileItem);
      data.form.file = fileList;
      data.fileList = fileList;
      if (fileItem.response?.msg && fileItem.response?.code != 0) {
        Message.error(fileItem.response?.msg);
      }
      if (fileList.filter((v) => !v.response).length == 0) {
        ctx.emit('cb');
        handleCancel();
      }
    };
    watch(
      () => data.form.file,
      (v) => {
        if (v.length >= 8) {
          formHeight.value = true;
        }
      },
      {
        deep: true
      }
    );
    //非空判断
    const addOptionRules = [
      {
        validator: (value, cb) => {
          const values = data.form.file.length;
          console.log(values);
          let tips = '';
          if (!values) {
            tips = '请上传本地附件';
            return cb(tips);
          }
          return;
        }
      }
    ];
    return {
      visible,
      cloudForm,
      formHeight,
      addOptionRules,
      uploadRef,
      uploadChange,
      beforeUpload,
      open,
      handleOk,
      handleCancel,
      handleSubmit,
      ...toRefs(data)
    };
  }
};
</script>
<style scoped lang="less">
@import './upload-attachment.less';
</style>
<style>
.cloud-modal .arco-modal-body {
  height: 400px;
  overflow: hidden;
  overflow-y: scroll;
}
</style>
